// This script waits for the page to fully load before running to ensure 
// all HTML elements, especially the canvas, are available.
document.addEventListener('DOMContentLoaded', function() {
    
    // Find the canvas element on the page.
    const canvas = document.getElementById('halftone-canvas');
    
    if (!canvas) {
        return;
    }

    const ctx = canvas.getContext('2d');

    // --- Configuration for Light Concrete Texture ---
    const baseColor = '#e5e5e5';      // Light off-white/warm grey base
    const noiseAmount = 40000;        // High grain count for that concrete feel
    const blotchCount = 60;           // Number of soft patches for unevenness
    const scratchCount = 6;           // A few subtle scuffs/cracks

    /**
     * Draws the texture pattern on the canvas.
     */
    function drawTexture() {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;

        // 1. Fill background with the solid light base color
        ctx.fillStyle = baseColor;
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // 2. Draw soft, blurred blotches for an organic concrete look
        for (let i = 0; i < blotchCount; i++) {
            const x = Math.random() * canvas.width;
            const y = Math.random() * canvas.height;
            const radius = Math.random() * 250 + 100; // Even larger, but softer
            
            // Create a radial gradient for soft, feathered edges
            const grad = ctx.createRadialGradient(x, y, 0, x, y, radius);
            const isDark = Math.random() > 0.5;
            
            if (isDark) {
                // Subtle dark cloud fading to transparent
                grad.addColorStop(0, 'rgba(0, 0, 0, 0.02)'); 
                grad.addColorStop(1, 'rgba(0, 0, 0, 0)');
            } else {
                // Subtle light cloud fading to transparent (drastically lowered opacity)
                grad.addColorStop(0, 'rgba(255, 255, 255, 0.06)'); 
                grad.addColorStop(1, 'rgba(255, 255, 255, 0)');
            }
            
            ctx.fillStyle = grad;
            ctx.beginPath();
            ctx.arc(x, y, radius, 0, 2 * Math.PI, false);
            ctx.fill();
        }

        // 3. Draw Noise (fine grain)
        for (let i = 0; i < noiseAmount; i++) {
            const x = Math.random() * canvas.width;
            const y = Math.random() * canvas.height;
            
            const isDarkGrain = Math.random() > 0.5;
            ctx.fillStyle = isDarkGrain ? 'rgba(0, 0, 0, 0.04)' : 'rgba(255, 255, 255, 0.4)';
            
            const size = Math.random() > 0.8 ? 2 : 1;
            ctx.fillRect(x, y, size, size);
        }

        // 4. Draw Scuffs / Subtle Cracks
        ctx.lineCap = 'round';
        const maxScratchLength = canvas.width / 5; 

        for (let i = 0; i < scratchCount; i++) {
            const startX = Math.random() * canvas.width;
            const startY = Math.random() * canvas.height;
            const angle = Math.random() * 2 * Math.PI;
            const length = Math.random() * maxScratchLength;
            
            for (let j = 0; j < 5; j++) {
                const segmentLength = length / 5;
                const prevX = startX + Math.cos(angle) * (segmentLength * j);
                const prevY = startY + Math.sin(angle) * (segmentLength * j);
                const currentX = startX + Math.cos(angle) * (segmentLength * (j + 1));
                const currentY = startY + Math.sin(angle) * (segmentLength * (j + 1));

                const wobbleX = (Math.random() - 0.5) * 6;
                const wobbleY = (Math.random() - 0.5) * 6;
                
                ctx.lineWidth = Math.random() * 2 + 0.5; 
                ctx.strokeStyle = 'rgba(0, 0, 0, 0.025)'; 

                ctx.beginPath();
                ctx.moveTo(prevX + wobbleX, prevY + wobbleY);
                ctx.lineTo(currentX + wobbleX, currentY + wobbleY);
                ctx.stroke();
            }
        }
    }

    // --- Event Listener for window resize ---
    if (window.innerWidth > 768) {
        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(drawTexture, 100);
        });
    }

    // --- Initial Draw ---
    drawTexture();
});